import React from "react";
import { SelectIntentArea } from "./Styled";
import { Input } from "antd";
import { Field } from "formik";
import { UserIntentNodeModel } from "../../../../model/workflowEditor";
import { Application } from "../../../../Application";
import { useSelector } from "react-redux";
import { Select } from "formik-antd";
import { selectIntentsMinimized } from "../../../../business/selectors/intentSelectors";
import BuilderContext from "../../../context/BuilderContext";
import BaseWidgetForm from "../baseWidgetForm/BaseWidgetForm";

type UserIntentFormProps = {
  node: UserIntentNodeModel;
  app: Application;
};

interface MyFormValues {
  title: string;
  selectedIntent: number | undefined;
}
const UserIntentForm: React.FunctionComponent<UserIntentFormProps> = ({
  node,
}) => {
  const { builder } = React.useContext(BuilderContext);
  const intents = useSelector(selectIntentsMinimized);
  const initialValues: MyFormValues = { title: node.title, selectedIntent: node.data.intentId };

  const onSubmit = (values: any) => {
    node.title = values.title;
    node.data.intentId = values.selectedIntent;
    builder?.repaint();
  }

  const renderForm = (formik: any) => {
    return <><Field
      name="title"
      // @ts-ignore
      render={({ field, form, meta }) => (
        <div>
          <Input type="text" {...field} placeholder="Title" />
          {meta.touched && meta.error && meta.error}
        </div>
      )}
    />
      {renderSelectField()}</>
  }


  const renderSelectField = () => {
    return (
      <SelectIntentArea>
        <Select
          name="selectedIntent"
          showSearch
          style={{ width: '100%' }}
          placeholder="Pick an intent"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {intents.map(({ id, title }) => { return <Select.Option value={id!}>{title}</Select.Option> })}
        </Select>
      </SelectIntentArea>
    );
  };

  return (
    <BaseWidgetForm
      title='USER INTENT'
      initialValues={initialValues}
      onSubmit={onSubmit}
      renderForm={renderForm}
    />
  );
};

export default UserIntentForm;